import { render, staticRenderFns } from "./FutureOrPastBanner.vue?vue&type=template&id=6284b090"
import script from "./FutureOrPastBanner.vue?vue&type=script&lang=js"
export * from "./FutureOrPastBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports